import { z } from 'zod';

export type PotentialBundle = z.infer<typeof PotentialBundle>;
export type BottleBundleCheck = z.infer<typeof BottleBundleCheck>;

export const PotentialBundle = z.object({
    itemId: z.string(),
    capacity: z.number(),
    weight: z.number(),
});

export const BottleBundleCheck = z.object({
    guid: z.string(),
    basketItemGuid: z.string(),
    correlationGuid: z.string().nullish(),
    potentialBundle: PotentialBundle,
    measuredWeight: z.number(),
    customerApproved: z.boolean(),
    customerApprovedOn: z.coerce.date().nullish(),
    customerChangedBasketToPotentialBundle: z.boolean(),
    customerSelectedItemId: z.string().nullish(),
    createdOn: z.coerce.date(),
});
